import ReactDom from "react-dom";

import MapAndInfo from "./MapAndInfo.jsx";

export default function renderHomepageMaps() {
  [...document.querySelectorAll(".js-homepage-map")].forEach((el) => {
    [...el.querySelectorAll(".js-homepage-map-mount")].forEach((mount) => {
      const rawData = JSON.parse(mount.dataset.model || {});
      const dictionaryData = JSON.parse(mount.dataset.dictionary || {});
      const countriesList = JSON.parse(mount.dataset.locations || []);
      const topicPages = rawData.TopicPages || [];
      const comparePageURL = rawData.comparePageURL || "/compare";
      const countryData = {};

      topicPages.forEach((page) => {
        // which topic does this page belong too.
        const topic = page.Title;
        const topicIcon = page.Icon || "";

        page.NarrativePages.forEach((narrative) => {
          if (narrative.Status !== "Active" &&
            narrative.Status !== "Inactive" &&
            narrative.Status !== "") {
            narrative.Locations.forEach((location) => {
              countryData[location] = countryData[location] || {};
              countryData[location].wip_case_studies =
                countryData[location].wip_case_studies || [];
              countryData[location].wip_case_studies.push({
                name: topic,
                icon: topicIcon,
              });
            });
          }

          if (narrative.Status === "Active" || narrative.Status === "") {
            narrative.Locations.forEach((location) => {
              countryData[location] = countryData[location] || {};
              countryData[location].case_studies =
                countryData[location].case_studies || [];
              countryData[location].case_studies.push({
                name: topic,
                icon: topicIcon,
                title: `${topic} in ${location}`.toUpperCase(),
                description: narrative.Summary,
                chart: narrative.TrendThumbnail,
                url: narrative.Url,
              });
            });
          }
        });
      });

      const home_worldmap_data = countriesList.map((country) => {
        const data = countryData[country.name] || {};

        const tempObject = {
          ...country,
          case_studies: data.case_studies || [],
          wip_case_studies: data.wip_case_studies || [],
          partner_content: country.partner_content || [],
          non_partner_content: country.non_partner_content || [],
        };

        return {
          ...tempObject,
          total:
            tempObject.case_studies.length > 0
              ? 2
              : tempObject.wip_case_studies.length > 0 ||
                tempObject.partner_content.length > 0 ||
                tempObject.non_partner_content.length > 0
                ? 1
                : 0,
        };
      });

      ReactDom.render(
        <MapAndInfo
          comparePageURL={comparePageURL}
          homeWorldmapData={home_worldmap_data}
          dictionaryData={dictionaryData}
        />,
        mount,
      );
    });
  });
}
